import { useStaticQuery, graphql } from "gatsby";

export default function useFooterSettings() {
  return useStaticQuery(graphql`
    query FooterSettings {
      wp {
        acfOptionsFooter {
          contactInformation {
            email
            phone
            postalAddress
          }
        }
      }
    }
  `).wp.acfOptionsFooter;
}
